import breakdownTokenize from './breakdownTokenize';

export default (breakdown, data, tokenContext, secondaryGeo) => {
  const { CAPTION, CAPTION_CMP } = breakdown.statements;
  return [CAPTION, (secondaryGeo.geo_code && CAPTION_CMP) || undefined]
    .filter((x) => x)
    .map(breakdownTokenize(breakdown, data, tokenContext))
    .join(' ');
};
